import type { CartItem, GiftcardCartItem } from '~/composables/types/cart'

export const useCartValidation = () => {
  const { cart } = useCartWithSubdomainLogic()
  const interval = ref()
  const { requireAgeOfMajority, handleValidationErrors } =
    useCartErrorHandlers()

  const getCartItemForValidation = (item: CartItem) => {
    const isGiftCard = item.type === 'GIFT_CARD'

    if (isGiftCard) {
      const giftcard = item as GiftcardCartItem
      return {
        type: giftcard.type,
        quantity: giftcard.quantity,
        value: parseInt(giftcard?.price?.amount || giftcard?.value),
        ship: giftcard.giftcardAddon !== 'PDF',
        ...(giftcard.giftcardAddon !== 'PDF'
          ? { ship_type: giftcard.giftcardAddon }
          : {}),
        ...(giftcard.eventDescriptionId
          ? { event: giftcard.eventDescriptionId }
          : {}),
      }
    }

    return {
      ...item,
      product: item.id,
      price: (parseInt(item.price.amount) / 100).toFixed(2),
    }
  }

  const performValidation = async () => {
    if (cart.value.items && cart.value.items.length === 0) return

    await kftApiRequest('/v1/checkout/cart/validate', {
      method: 'POST',
      body: {
        items: cart.value.items.map(getCartItemForValidation),
      },
    }).catch((e) => {
      handleValidationErrors(e)
    })
  }

  const setupValidationPolling = () => {
    performValidation()
    const oneMinute = 60000
    interval.value = setInterval(performValidation, oneMinute * 10)
  }
  const deactivateValidationPolling = () => {
    clearInterval(interval.value)
  }

  return {
    requireAgeOfMajority,
    setupValidationPolling,
    performValidation,
    deactivateValidationPolling,
  }
}
